module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/home-category-178-dad53a.svg";